export default __webpack_public_path__ + "static/media/lista_submin.f7514545.svg";